import { FInter, Colors } from "@brg/ui";
import { LayoutConst } from "../../../core";
import styled from "styled-components";

export const Title = styled(FInter.SectionTitle)`
  display: flex;
  flex-wrap: wrap;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;

  .prefix-title {
    margin-right: 8px;
  }
  color: ${({ theme }) => theme.projectView.titleColor};

  @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 23px;
    line-height: 29px;
  }

  @media (max-width: 940px) {
    font-size: 24px;
    line-height: 26px;

    .prefix-title {
      margin-right: 6px;
    }
  }
`;

export const DescriptionBlock = styled.div`
  width: 100%;
  font-family: Inter;
  letter-spacing: -0.02em;
  background-color: ${Colors.galBlack5};
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
`;

export const DescriptionTitle = styled.div`
  font-size: 17px;
  font-weight: 600;
  color: ${Colors.galBlack100};
  margin-bottom: 8px;
`;

export const DescriptionListItem = styled.div`
  font-size: 17px;
  line-height: 22px;
  color: ${Colors.galBlack100};
`;

export const DescriptionComment = styled.div`
  font-size: 15px;
  line-height: 20px;
  color: ${Colors.galBlack61};
  text-align: left;
  margin-top: 8px;
`;

export const Header = styled.div`
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: 24px;
  }

  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const LinkWithForm = styled.a`
  color: #0050cf !important;

  &:hover {
    text-decoration: underline !important;
  }
`;

export const ContentContainer = styled.div`
  margin-top: 24px;

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin-top: 16px;
  }
`;
import { FInter, Colors } from "@brg/ui";
import { LayoutConst } from "../../../core";
import styled from "styled-components";

export const Title = styled(FInter.SectionTitle)`
  display: flex;
  flex-wrap: wrap;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;

  .prefix-title {
    margin-right: 8px;
  }
  color: ${({ theme }) => theme.projectView.titleColor};

  @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 23px;
    line-height: 29px;
  }

  @media (max-width: 940px) {
    font-size: 24px;
    line-height: 26px;

    .prefix-title {
      margin-right: 6px;
    }
  }
`;

export const DescriptionBlock = styled.div`
  width: 100%;
  font-family: Inter;
  letter-spacing: -0.02em;
  background-color: ${Colors.galBlack5};
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
`;

export const DescriptionTitle = styled.div`
  font-size: 17px;
  font-weight: 600;
  color: ${Colors.galBlack100};
  margin-bottom: 8px;
`;

export const DescriptionListItem = styled.div`
  font-size: 17px;
  line-height: 22px;
  color: ${Colors.galBlack100};
`;

export const DescriptionComment = styled.div`
  font-size: 15px;
  line-height: 20px;
  color: ${Colors.galBlack61};
  text-align: left;
  margin-top: 8px;
`;

export const Header = styled.div`
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: 24px;
  }

  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const LinkWithForm = styled.a`
  color: #0050cf !important;

  &:hover {
    text-decoration: underline !important;
  }
`;

export const ContentContainer = styled.div`
  margin-top: 24px;

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin-top: 16px;
  }
`;
